import React, { FunctionComponent } from 'react';
import { AdminApiConnectionUpdate } from 'src/api';
import Hint from 'src/ui/atoms/hint';
import Translate from 'src/ui/atoms/translate';
import { Modal, ModalContent, ModalFooter, ModalFooterButtons, ModalHeader } from 'src/ui/molecules/modal';

interface EditApiConnectionSuccessModalProps {
  onClose: () => void;
  editedApiConnection?: AdminApiConnectionUpdate;
}

const EditApiConnectionSuccessModal: FunctionComponent<EditApiConnectionSuccessModalProps> = ({
  editedApiConnection,
  onClose,
}) => {
  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="editApiConnectionSuccessModal.title" />
      </ModalHeader>
      <ModalContent>
        <Hint variant="success">
          <Translate
            name="editApiConnectionSuccessModal.successHintNoSecret"
            as="span"
            args={[<strong>{editedApiConnection?.name}</strong>]}
          />
        </Hint>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          align="end"
          actionButtons={[
            {
              name: 'close',
              content: <Translate name="common.close" />,
              size: 'large',
              onClick: onClose,
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default EditApiConnectionSuccessModal;
